const LEGACY_API_CACHE = 'api-cache';

export async function removeLegacyApiCache(cacheStorage: Pick<CacheStorage, 'delete'> | undefined = globalThis.caches) {
  if (!cacheStorage) return false;
  return cacheStorage.delete(LEGACY_API_CACHE);
}
